import {createStore, applyMiddleware, compose, combineReducers} from 'redux';
import reduxThunk from 'redux-thunk';

import scanpackReducer from '../reducers/scanpackReducer';
import updateUrlReducer from '../reducers/updateUrlReducer';
import productReducer from '../reducers/productReducer';
import orderReducer from '../reducers/orderReducer';
import userReducer from '../reducers/userReducer';
import statisticsReducer from '../reducers/statisticsReducer';
import updateAsyncReducer from '../reducers/updateAsyncReducer';
import saveLogReducer from '../reducers/saveLogReducer';
import headerReducer from '../reducers/headerReducer';
import menuReducer from '../reducers/menuReducer ';
import importorderReducer from '../reducers/importorderReducer';
import orderLoaderReducer from '../reducers/orderLoaderReducer';
import orderTagPriorityReducer from '../reducers/tagPriorityReducer';
import scanToCartReducer from '../reducers/scanToCartReducer';
import scanToCartScanningReducer from '../reducers/scanningReducer';
import productFirstReducer from '../reducers/productFirstReducer';
import scanPackScanningReducer from '../reducers/scanpackScanningReducer';
import inventoryReportsReducer from '../reducers/inventoryReportsReducer';
import zoneReducer from '../reducers/zoneReducer';
import savedFiltersReducer from '../reducers/savedFiltersReducer';
import cameraScannerReducer from '../reducers/cameraScannerReducer';
import rulesReducer from '../reducers/rulesReducer';
import boxChampReducer from '../reducers/boxChampReducer';
import featuresReducer from '../reducers/featuresReducer';
import wmsReducer from '../reducers/wmsReducer';
import costCalculatorReducer from '../reducers/costCalculatorReducer';
import adminTenantsReducer from '../reducers/adminTenantsReducer';
import adminTenantPageReducer from '../reducers/adminTenantPageReducer';
import lotMetadataReportReducer from '../reducers/lotMetadataReportReducer';

const rootReducer = combineReducers({
  scanpack: scanpackReducer,
  updateUrl: updateUrlReducer,
  product: productReducer,
  order: orderReducer,
  statistics: statisticsReducer,
  user: userReducer,
  updateAsync: updateAsyncReducer,
  saveLog: saveLogReducer,
  header: headerReducer,
  menu: menuReducer,
  importOrder: importorderReducer,
  orderLoader: orderLoaderReducer,
  tagPriority: orderTagPriorityReducer,
  scanToCart:scanToCartReducer,
  scanToCartScanning: scanToCartScanningReducer,
  productFirst: productFirstReducer,
  scanPackScanning: scanPackScanningReducer,
  inventoryReports: inventoryReportsReducer,
  zone: zoneReducer,
  savedFilters: savedFiltersReducer,
  cameraScanner: cameraScannerReducer,
  rules: rulesReducer,
  boxChamp: boxChampReducer,
  features: featuresReducer,
  wms: wmsReducer,
  costCalculator: costCalculatorReducer,
  adminTenants: adminTenantsReducer,
  adminTenantPage: adminTenantPageReducer,
  lotMetadataReport: lotMetadataReportReducer
});

const middleware = applyMiddleware(reduxThunk);
const enhancer = compose(middleware);

const configureStore = preloadedState => {
  return createStore(rootReducer, preloadedState, enhancer);
};

export default configureStore;
